import _slicedToArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import servicesUtils from "../utils/servicesUtils";
import Store from "../utils/Store";
export var getUserSettings = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var settingsData;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _context.n = 1;
          return servicesUtils.getService("/settings/");
        case 1:
          settingsData = _context.v;
          Store.update(function (store) {
            // eslint-disable-next-line no-param-reassign
            store.userSettings = settingsData && settingsData.settings ? settingsData : {};
          });
        case 2:
          return _context.a(2);
      }
    }, _callee);
  }));
  return function getUserSettings() {
    return _ref.apply(this, arguments);
  };
}();
export var getAppConfig = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
    var configData;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          _context2.n = 1;
          return servicesUtils.getService("/configs/");
        case 1:
          configData = _context2.v;
          Store.update(function (store) {
            // eslint-disable-next-line no-param-reassign
            store.appConfig = configData || {};
          });
          return _context2.a(2, configData);
      }
    }, _callee2);
  }));
  return function getAppConfig() {
    return _ref2.apply(this, arguments);
  };
}();
export var getAccountConfig = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(email) {
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          return _context3.a(2, servicesUtils.getService("/ops/lc_workspace/accounts/config/?email=".concat(encodeURIComponent(email))));
      }
    }, _callee3);
  }));
  return function getAccountConfig(_x) {
    return _ref3.apply(this, arguments);
  };
}();
export var updateAccountUiSettings = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(email, dob_format, disable_ai_reports_and_tags, show_new_viewer, show_support_widget_portal) {
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          return _context4.a(2, servicesUtils.patchService("/ops/lc_workspace/accounts/ui_settings/", _objectSpread(_objectSpread(_objectSpread(_objectSpread({
            email: email
          }, dob_format !== undefined && {
            dob_format: dob_format
          }), disable_ai_reports_and_tags !== undefined && {
            disable_ai_reports_and_tags: disable_ai_reports_and_tags
          }), show_new_viewer !== undefined && {
            show_new_viewer: show_new_viewer
          }), show_support_widget_portal !== undefined && {
            show_support_widget_portal: show_support_widget_portal
          })));
      }
    }, _callee4);
  }));
  return function updateAccountUiSettings(_x2, _x3, _x4, _x5, _x6) {
    return _ref4.apply(this, arguments);
  };
}();
export var updateAccountAISettings = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(email, ai_assistant) {
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.n) {
        case 0:
          return _context5.a(2, servicesUtils.patchService("/ops/lc_workspace/accounts/ai_settings/", {
            email: email,
            ai_assistant: ai_assistant
          }));
      }
    }, _callee5);
  }));
  return function updateAccountAISettings(_x7, _x8) {
    return _ref5.apply(this, arguments);
  };
}();
export var getAccounts = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(email) {
    return _regenerator().w(function (_context6) {
      while (1) switch (_context6.n) {
        case 0:
          return _context6.a(2, servicesUtils.getService("/ops/lc_workspace/accounts/".concat(email ? "?email=".concat(encodeURIComponent(email)) : "")));
      }
    }, _callee6);
  }));
  return function getAccounts(_x9) {
    return _ref6.apply(this, arguments);
  };
}();
export var createAccount = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(payload) {
    return _regenerator().w(function (_context7) {
      while (1) switch (_context7.n) {
        case 0:
          return _context7.a(2, servicesUtils.postService("/ops/lc_workspace/accounts/", payload));
      }
    }, _callee7);
  }));
  return function createAccount(_x0) {
    return _ref7.apply(this, arguments);
  };
}();
export var createQTrackAccount = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(params) {
    var qTrackAccount;
    return _regenerator().w(function (_context8) {
      while (1) switch (_context8.n) {
        case 0:
          _context8.n = 1;
          return servicesUtils.postService("/ops/lc_workspace_creation/", params);
        case 1:
          qTrackAccount = _context8.v;
          return _context8.a(2, qTrackAccount);
      }
    }, _callee8);
  }));
  return function createQTrackAccount(_x1) {
    return _ref8.apply(this, arguments);
  };
}();
export var getDraft = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(workspace_name) {
    return _regenerator().w(function (_context9) {
      while (1) switch (_context9.n) {
        case 0:
          return _context9.a(2, servicesUtils.getService("/ops/onboarding_draft/?workspace_name=".concat(encodeURIComponent(workspace_name))));
      }
    }, _callee9);
  }));
  return function getDraft(_x10) {
    return _ref9.apply(this, arguments);
  };
}();
export var saveDraft = /*#__PURE__*/function () {
  var _ref0 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(workspace_name, data) {
    return _regenerator().w(function (_context0) {
      while (1) switch (_context0.n) {
        case 0:
          return _context0.a(2, servicesUtils.postService("/ops/onboarding_draft/", {
            workspace_name: workspace_name,
            data: data
          }));
      }
    }, _callee0);
  }));
  return function saveDraft(_x11, _x12) {
    return _ref0.apply(this, arguments);
  };
}();
export var deleteDraft = /*#__PURE__*/function () {
  var _ref1 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(workspace_name) {
    return _regenerator().w(function (_context1) {
      while (1) switch (_context1.n) {
        case 0:
          return _context1.a(2, servicesUtils.deleteService("/ops/onboarding_draft/?workspace_name=".concat(encodeURIComponent(workspace_name))));
      }
    }, _callee1);
  }));
  return function deleteDraft(_x13) {
    return _ref1.apply(this, arguments);
  };
}();
export var getWorkspaces = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(name) {
    var query;
    return _regenerator().w(function (_context10) {
      while (1) switch (_context10.n) {
        case 0:
          query = name ? "?name=".concat(encodeURIComponent(name)) : "";
          return _context10.a(2, servicesUtils.getService("/ops/workspace_list/".concat(query)));
      }
    }, _callee10);
  }));
  return function getWorkspaces(_x14) {
    return _ref10.apply(this, arguments);
  };
}();

/** Read the onboarding audit log, scoped by workspace_name or email (≥1 required). */
export var getOnboardingAuditLog = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(params) {
    var query, qs;
    return _regenerator().w(function (_context11) {
      while (1) switch (_context11.n) {
        case 0:
          query = new URLSearchParams();
          Object.entries(params).forEach(function (_ref12) {
            var _ref13 = _slicedToArray(_ref12, 2),
              key = _ref13[0],
              value = _ref13[1];
            if (value !== undefined && value !== null && value !== "") {
              query.append(key, String(value));
            }
          });
          qs = query.toString();
          return _context11.a(2, servicesUtils.getService("/ops/onboarding/audit_log/".concat(qs ? "?".concat(qs) : "")));
      }
    }, _callee11);
  }));
  return function getOnboardingAuditLog(_x15) {
    return _ref11.apply(this, arguments);
  };
}();
export var getFormExportNames = /*#__PURE__*/function () {
  var _ref14 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(workspaceId) {
    return _regenerator().w(function (_context12) {
      while (1) switch (_context12.n) {
        case 0:
          return _context12.a(2, servicesUtils.getService("/workspaces/".concat(workspaceId, "/forms/export/names/")));
      }
    }, _callee12);
  }));
  return function getFormExportNames(_x16) {
    return _ref14.apply(this, arguments);
  };
}();
export var getFormExportJson = /*#__PURE__*/function () {
  var _ref15 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(workspaceId, formName) {
    return _regenerator().w(function (_context13) {
      while (1) switch (_context13.n) {
        case 0:
          return _context13.a(2, servicesUtils.getService("workspaces/".concat(workspaceId, "/forms/").concat(formName, "/export/schema/")));
      }
    }, _callee13);
  }));
  return function getFormExportJson(_x17, _x18) {
    return _ref15.apply(this, arguments);
  };
}();
export var getLCDefaultForms = /*#__PURE__*/function () {
  var _ref16 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14() {
    return _regenerator().w(function (_context14) {
      while (1) switch (_context14.n) {
        case 0:
          return _context14.a(2, servicesUtils.getService("/ops/lc_default_forms/?names_only=true"));
      }
    }, _callee14);
  }));
  return function getLCDefaultForms() {
    return _ref16.apply(this, arguments);
  };
}();
export var getLCDefaultFormSchema = /*#__PURE__*/function () {
  var _ref17 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15() {
    return _regenerator().w(function (_context15) {
      while (1) switch (_context15.n) {
        case 0:
          return _context15.a(2, servicesUtils.getService("/ops/lc_default_forms/"));
      }
    }, _callee15);
  }));
  return function getLCDefaultFormSchema() {
    return _ref17.apply(this, arguments);
  };
}();
export var getWorkspaceConfig = /*#__PURE__*/function () {
  var _ref18 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16(workspace_name) {
    return _regenerator().w(function (_context16) {
      while (1) switch (_context16.n) {
        case 0:
          return _context16.a(2, servicesUtils.getService("/ops/workspace_config/?workspace_name=".concat(encodeURIComponent(workspace_name))));
      }
    }, _callee16);
  }));
  return function getWorkspaceConfig(_x19) {
    return _ref18.apply(this, arguments);
  };
}();
export var createWorkspaceMember = /*#__PURE__*/function () {
  var _ref19 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17(body) {
    return _regenerator().w(function (_context17) {
      while (1) switch (_context17.n) {
        case 0:
          return _context17.a(2, servicesUtils.postService("/ops/lc_workspace/create_member/", body));
      }
    }, _callee17);
  }));
  return function createWorkspaceMember(_x20) {
    return _ref19.apply(this, arguments);
  };
}();
export var getWorkspaceMembers = /*#__PURE__*/function () {
  var _ref20 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee18(workspace_name) {
    return _regenerator().w(function (_context18) {
      while (1) switch (_context18.n) {
        case 0:
          return _context18.a(2, servicesUtils.getService("/ops/lc_workspace/members/?workspace_name=".concat(encodeURIComponent(workspace_name))));
      }
    }, _callee18);
  }));
  return function getWorkspaceMembers(_x21) {
    return _ref20.apply(this, arguments);
  };
}();
export var addExistingWorkspaceMember = /*#__PURE__*/function () {
  var _ref21 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee19(body) {
    return _regenerator().w(function (_context19) {
      while (1) switch (_context19.n) {
        case 0:
          return _context19.a(2, servicesUtils.postService("/ops/lc_workspace/members/", body));
      }
    }, _callee19);
  }));
  return function addExistingWorkspaceMember(_x22) {
    return _ref21.apply(this, arguments);
  };
}();
export var checkWorkspaceAccount = /*#__PURE__*/function () {
  var _ref22 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee20(email) {
    return _regenerator().w(function (_context20) {
      while (1) switch (_context20.n) {
        case 0:
          return _context20.a(2, servicesUtils.getService("/ops/lc_workspace/check_account/?email=".concat(encodeURIComponent(email))));
      }
    }, _callee20);
  }));
  return function checkWorkspaceAccount(_x23) {
    return _ref22.apply(this, arguments);
  };
}();
export var getAccountMemberships = /*#__PURE__*/function () {
  var _ref23 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee21(email) {
    return _regenerator().w(function (_context21) {
      while (1) switch (_context21.n) {
        case 0:
          return _context21.a(2, servicesUtils.getService("/ops/lc_workspace/account_memberships/?email=".concat(encodeURIComponent(email))));
      }
    }, _callee21);
  }));
  return function getAccountMemberships(_x24) {
    return _ref23.apply(this, arguments);
  };
}();
export var getAIRAConfigs = /*#__PURE__*/function () {
  var _ref24 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee22() {
    return _regenerator().w(function (_context22) {
      while (1) switch (_context22.n) {
        case 0:
          return _context22.a(2, servicesUtils.getService("/ops/aira-configs/"));
      }
    }, _callee22);
  }));
  return function getAIRAConfigs() {
    return _ref24.apply(this, arguments);
  };
}();
export var getLlmWorkflows = /*#__PURE__*/function () {
  var _ref25 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee23() {
    return _regenerator().w(function (_context23) {
      while (1) switch (_context23.n) {
        case 0:
          return _context23.a(2, servicesUtils.getService("/ops/llm_workflows/"));
      }
    }, _callee23);
  }));
  return function getLlmWorkflows() {
    return _ref25.apply(this, arguments);
  };
}();
export var getLCFilters = /*#__PURE__*/function () {
  var _ref26 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee24() {
    return _regenerator().w(function (_context24) {
      while (1) switch (_context24.n) {
        case 0:
          return _context24.a(2, servicesUtils.getService("/ops/lc_filters/"));
      }
    }, _callee24);
  }));
  return function getLCFilters() {
    return _ref26.apply(this, arguments);
  };
}();
export var updateUiSettings = /*#__PURE__*/function () {
  var _ref27 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee25(workspace_name, ui_settings) {
    return _regenerator().w(function (_context25) {
      while (1) switch (_context25.n) {
        case 0:
          return _context25.a(2, servicesUtils.patchService("/ops/workspace_config/ui_settings/", {
            workspace_name: workspace_name,
            ui_settings: ui_settings
          }));
      }
    }, _callee25);
  }));
  return function updateUiSettings(_x25, _x26) {
    return _ref27.apply(this, arguments);
  };
}();
export var updateCaseAdditionConfig = /*#__PURE__*/function () {
  var _ref28 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee26(workspace_name, case_addition_config) {
    return _regenerator().w(function (_context26) {
      while (1) switch (_context26.n) {
        case 0:
          return _context26.a(2, servicesUtils.patchService("/ops/workspace_config/case_addition/", {
            workspace_name: workspace_name,
            case_addition_config: case_addition_config
          }));
      }
    }, _callee26);
  }));
  return function updateCaseAdditionConfig(_x27, _x28) {
    return _ref28.apply(this, arguments);
  };
}();
export var updateAgenticWorkflowsConfig = /*#__PURE__*/function () {
  var _ref29 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee27(workspace_name, agentic_workflows_config) {
    return _regenerator().w(function (_context27) {
      while (1) switch (_context27.n) {
        case 0:
          return _context27.a(2, servicesUtils.patchService("/ops/workspace_config/agentic_workflows/", {
            workspace_name: workspace_name,
            agentic_workflows_config: agentic_workflows_config
          }));
      }
    }, _callee27);
  }));
  return function updateAgenticWorkflowsConfig(_x29, _x30) {
    return _ref29.apply(this, arguments);
  };
}();
export var updateCustomTags = /*#__PURE__*/function () {
  var _ref30 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee28(workspace_name, custom_tags) {
    var clear,
      _args28 = arguments;
    return _regenerator().w(function (_context28) {
      while (1) switch (_context28.n) {
        case 0:
          clear = _args28.length > 2 && _args28[2] !== undefined ? _args28[2] : false;
          return _context28.a(2, servicesUtils.patchService("/ops/workspace_config/custom_tags/", _objectSpread({
            workspace_name: workspace_name,
            custom_tags: custom_tags
          }, clear ? {
            clear: true
          } : {})));
      }
    }, _callee28);
  }));
  return function updateCustomTags(_x31, _x32) {
    return _ref30.apply(this, arguments);
  };
}();
export var getUserFilters = /*#__PURE__*/function () {
  var _ref31 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee29(email) {
    return _regenerator().w(function (_context29) {
      while (1) switch (_context29.n) {
        case 0:
          return _context29.a(2, servicesUtils.getService("/ops/lc_workspace/user_filters/?email=".concat(encodeURIComponent(email))));
      }
    }, _callee29);
  }));
  return function getUserFilters(_x33) {
    return _ref31.apply(this, arguments);
  };
}();
export var updateUserFilters = /*#__PURE__*/function () {
  var _ref32 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee30(email, selected_saved_filters, selected_discordance_filters) {
    return _regenerator().w(function (_context30) {
      while (1) switch (_context30.n) {
        case 0:
          return _context30.a(2, servicesUtils.patchService("/ops/lc_workspace/user_filters/", {
            email: email,
            selected_saved_filters: selected_saved_filters,
            selected_discordance_filters: selected_discordance_filters
          }));
      }
    }, _callee30);
  }));
  return function updateUserFilters(_x34, _x35, _x36) {
    return _ref32.apply(this, arguments);
  };
}();
export var updateWorkspaceLetters = /*#__PURE__*/function () {
  var _ref33 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee31(workspace_name, letters) {
    var clear,
      _args31 = arguments;
    return _regenerator().w(function (_context31) {
      while (1) switch (_context31.n) {
        case 0:
          clear = _args31.length > 2 && _args31[2] !== undefined ? _args31[2] : false;
          return _context31.a(2, servicesUtils.patchService("/ops/workspace_config/letters/", _objectSpread({
            workspace_name: workspace_name,
            letters: letters
          }, clear ? {
            clear: true
          } : {})));
      }
    }, _callee31);
  }));
  return function updateWorkspaceLetters(_x37, _x38) {
    return _ref33.apply(this, arguments);
  };
}();
export var updateDeepLearning = /*#__PURE__*/function () {
  var _ref34 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee32(workspace_name, settings) {
    return _regenerator().w(function (_context32) {
      while (1) switch (_context32.n) {
        case 0:
          return _context32.a(2, servicesUtils.patchService("/ops/workspace_config/deep_learning/", _objectSpread({
            workspace_name: workspace_name
          }, settings)));
      }
    }, _callee32);
  }));
  return function updateDeepLearning(_x39, _x40) {
    return _ref34.apply(this, arguments);
  };
}();
export var updateWorkspaceForms = /*#__PURE__*/function () {
  var _ref35 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee33(workspace_name, selected_forms, custom_forms) {
    return _regenerator().w(function (_context33) {
      while (1) switch (_context33.n) {
        case 0:
          return _context33.a(2, servicesUtils.patchService("/ops/workspace_config/forms/", {
            workspace_name: workspace_name,
            selected_forms: selected_forms,
            custom_forms: custom_forms
          }));
      }
    }, _callee33);
  }));
  return function updateWorkspaceForms(_x41, _x42, _x43) {
    return _ref35.apply(this, arguments);
  };
}();